import { ArrowLeft, Settings as SettingsIcon } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { SportsManager } from './components/settings/SportsManager';
import { AgeBracketsManager } from './components/settings/AgeBracketsManager';
import { SkillLevelsManager } from './components/settings/SkillLevelsManager';
import { LocationsManager } from './components/settings/LocationsManager';

type Tab = 'sports' | 'age' | 'skill' | 'locations';

const TABS: { key: Tab; label: string }[] = [
  { key: 'sports', label: 'Sports' },
  { key: 'age', label: 'Age Brackets' },
  { key: 'skill', label: 'Skill Levels' },
  { key: 'locations', label: 'Locations' },
];

export default function ScheduleSettings() {
  const [tab, setTab] = useState<Tab>('sports');

  return (
    <div className="flex-1 flex flex-col min-h-0 bg-[#111010]">
      <div className="border-b border-white/10 pb-3 md:pb-4 shrink-0 px-4 md:px-6 pt-4">
        <div className="flex items-center gap-3">
          <Link
            to="/schedule"
            className="p-1.5 text-[#A9A3A3] hover:text-[#EBFFEE] hover:bg-[#363232] rounded-lg transition-colors"
          >
            <ArrowLeft size={18} />
          </Link>
          <SettingsIcon size={22} className="text-rollops-accent" />
          <h1 className="text-text-primary font-heading text-2xl md:text-3xl font-bold">
            Schedule Settings
          </h1>
        </div>
        <p className="text-white/60 mt-1 text-sm">
          Configure the sports, age brackets, skill levels, and locations available when creating classes.
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-white/10 shrink-0 px-4 md:px-6">
        <div className="flex gap-1 overflow-x-auto">
          {TABS.map((t) => {
            const active = tab === t.key;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  active
                    ? 'border-[#9B1421] text-[#EBFFEE]'
                    : 'border-transparent text-[#A9A3A3] hover:text-[#EBFFEE]'
                }`}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab body */}
      <div className="flex-1 overflow-auto px-4 md:px-6 py-5">
        {tab === 'sports' && <SportsManager />}
        {tab === 'age' && <AgeBracketsManager />}
        {tab === 'skill' && <SkillLevelsManager />}
        {tab === 'locations' && <LocationsManager />}
      </div>
    </div>
  );
}
